import { useEffect, useState, useRef } from 'react'
import { useMap } from 'react-leaflet'
import { Location } from '@hooks/useGeolocation'

interface MapFollowControllerProps {
  userLocation: Location | null
  enabled?: boolean
}

export function MapFollowController({ userLocation, enabled = true }: MapFollowControllerProps) {
  const map = useMap()
  const [hasUserMovedMap, setHasUserMovedMap] = useState(false)
  const initialCenterSet = useRef(false)

  useEffect(() => {
    if (!enabled) return

    // Track when user manually interacts with the map
    const handleUserInteraction = () => {
      setHasUserMovedMap(true)
    }

    // Listen to map movement events (including moveend for viewport searches)
    map.on('dragstart', handleUserInteraction)
    map.on('zoomstart', handleUserInteraction)
    map.on('moveend', handleUserInteraction)

    return () => {
      map.off('dragstart', handleUserInteraction)
      map.off('zoomstart', handleUserInteraction)
      map.off('moveend', handleUserInteraction)
    }
  }, [map, enabled])

  useEffect(() => {
    // Only set initial position ONCE, then never move the map again
    if (!enabled || !userLocation || userLocation.source !== 'gps') return

    // If we already set the initial center, never move again
    if (initialCenterSet.current) return

    // Set the initial position
    console.log('🗺️ MapFollowController: Setting initial GPS position')
    map.setView([userLocation.latitude, userLocation.longitude], map.getZoom(), {
      animate: true,
      duration: 1,
    })
    initialCenterSet.current = true
  }, [userLocation, map, enabled])

  return null
}
